// 商品 植物図鑑 — Splide（SP 247px / PC 332px）

function mountProductPlantGuideSplide(root) {
  if (!root || root.dataset.splideMounted === 'true' || typeof Splide === 'undefined') return;

  const splide = new Splide(root, {
    type: 'slide',
    fixedWidth: '332px',
    gap: '16px',
    arrows: false,
    pagination: false,
    perMove: 1,
    drag: true,
    breakpoints: {
      767: {
        fixedWidth: '247px',
        gap: '16px',
      },
    },
  });

  splide.mount();
  root.dataset.splideMounted = 'true';
  root.splideInstance = splide;
}

function destroyProductPlantGuideSplide(root) {
  if (!root?.splideInstance) return;

  root.splideInstance.destroy();
  delete root.splideInstance;
  delete root.dataset.splideMounted;
}

function initProductPlantGuideSections(container = document) {
  container.querySelectorAll('[data-cm-product-plant-guide-splide]').forEach(mountProductPlantGuideSplide);
}

function destroyProductPlantGuideSections(container = document) {
  container.querySelectorAll('[data-cm-product-plant-guide-splide]').forEach(destroyProductPlantGuideSplide);
}

document.addEventListener('DOMContentLoaded', () => {
  initProductPlantGuideSections();
});

document.addEventListener('shopify:section:load', (event) => {
  initProductPlantGuideSections(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  destroyProductPlantGuideSections(event.target);
});
